import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_mto_component_label_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  mto_component_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_guid : fromDatatype.GuidDataFieldInterface;
  descr: fromDatatype.TextDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.NamespaceDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  negation_logic: boolean;
}

export class bl_fi_mto_component_label_link_RowClass implements bl_fi_mto_component_label_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  mto_component_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_guid : fromDatatype.GuidDataFieldInterface;
  descr: fromDatatype.TextDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.NamespaceDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  negation_logic: boolean;
}
